var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6C58A998-CDE7-4177-9313-E65D8B97FB53") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-889.000000, -610.000000)",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M901.49567,625.420104 L896.28093,620.148407 C895.896937,619.76022 895.895313,619.135781 896.277283,618.745602 L898.010125,616.975516 C898.39135,616.586098 898.390582,615.963137 898.0084,615.574659 L894.192357,611.695762 C893.811667,611.308801 893.191785,611.296213 892.795699,611.667399 L890.2032,614.096918 C889.387257,617.898065 891.02861,621.790421 895.127259,625.773987 C899.225907,629.757553 903.268772,631.463742 907.255854,630.892556 L909.371976,628.489655 C909.723887,628.090053 909.700953,627.484781 909.319814,627.112954 L905.886768,623.763786 C905.491444,623.378121 904.858327,623.385951 904.472662,623.781275 C904.469409,623.78461 904.466179,623.787967 904.462973,623.791347 L902.932094,625.405084 C902.551992,625.80576 901.919047,625.822437 901.518371,625.442335 C901.510687,625.435045 901.503119,625.427634 901.49567,625.420104 Z",
    id: "phone"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPhone);
export default __webpack_public_path__ + "static/media/ico_phone.5923193b2e2797d220c3dbb9f5410905.svg";
export { ForwardRef as ReactComponent };